import React from 'react';
import Search from './Search';

const Mid = ({ search }) => (
    search || <Search />
);

export default Mid;
